var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "105.000000pt",
    height: "115.000000pt",
    viewBox: "0 0 105.000000 115.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,115.000000) scale(0.100000,-0.100000)",
    fill: "#ffffff",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M425 1122 c-93 -52 -340 -219 -367 -248 -56 -60 -58 -74 -58 -440 0 -369 2 -383 59 -417 26 -15 72 -17 463 -17 411 0 435 1 465 20 58 35 58 33 58 415 0 450 23 400 -261 584 -95 61 -184 115 -199 121 -48 18 -107 11 -160 -18z m239 -117 c214 -137 261 -171 283 -204 23 -34 23 -38 23 -367 0 -333 0 -333 -22 -348 -19 -14 -77 -16 -428 -16 -335 0 -410 2 -426 14 -18 14 -19 31 -22 338 -3 413 -21 370 218 526 96 62 184 117 195 122 35 16 76 1 179 -65z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252 268 c-7 -7 -12 -19 -12 -28 0 -38 17 -40 276 -40 139 0 259 3 268 6 21 8 21 60 0 68 -9 3 -129 6 -268 6 -183 0 -255 -3 -264 -12z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.ff821945b695047bb3be6ffa4381e902.svg";
export { ForwardRef as ReactComponent };